import { useRef, useState } from 'react';
import { Defer } from '@cian/valuation-utils-component';

/** Для предотвращения сабмита во время загрузки мы используем Defer объект с промисом **/
export const useUploadingState = () => {
  const [isLoading, _setIsLoading] = useState(false);
  const ref = useRef<Defer | undefined>();

  const setIsLoading = (state: boolean) => {
    _setIsLoading(state);
    if (state) {
      ref.current = new Defer();
    } else if (ref.current) {
      ref.current.resolve();
    }
  };

  const waitForFinish = () => ref.current && ref.current.promise;

  return {
    isLoading,
    setIsLoading,
    waitForFinish,
  };
};
